import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from "react-router-dom";
import PageMenu from 'components/blocks/PageMenu/PageMenu'
import IconArrowGray from "../../../../img/icons/svg/botones/flecha-big-gris.svg";
import { useParams } from 'react-router-dom';
import Loader from 'components/blocks/Loader/Loader';
import useDecode from 'hooks/useDecode';
import SolicitudPrestacionesEspeciales from './SolicitudPrestacionesEspeciales';
import useGetSolicitudPrestacionesEspecialesByID from 'services/record/SolicitudPrestacionesEspeciales/useGetSolicitudPrestacionesEspecialesByID';
interface Params {
    idprestacion: string;
    idform: string;
}


const HistorialSolicitudPrestacionesEspeciales = ({ expedienteId = null, origen = null }) => {
    const decoded = useDecode("token");
    const userId = decoded?.extension_id;
    const [data, setData] = useState(null);
    const location = useLocation();
    const navigate = useNavigate()
    const { dataGetSolicitudPrestacionesEspecialesByID, errorGetSolicitudPrestacionesEspecialesByID, getSolicitudPrestacionesEspecialesByID, loadingGetSolicitudPrestacionesEspecialesByID, successGetSolicitudPrestacionesEspecialesByID } = useGetSolicitudPrestacionesEspecialesByID();
    const { idprestacion, idform } = useParams<Record<string, string>>();
    const origenValue = location?.state?.origen ?? origen ?? null;
    const expedienteIdValue = location?.state?.expedienteId ?? expedienteId ?? null;
    const expedienteIdByOrigen = Number(origenValue) === 1 ? (expedienteIdValue ?? null) : null;
    const dataUserWithExpedienteByOrigen = (payload) => (expedienteIdByOrigen !== null && expedienteIdByOrigen !== undefined ? { ...payload, ExpedienteId: expedienteIdByOrigen } : payload);


    useEffect(() => {
        const actualUrl = window.location.href;
        if (!actualUrl.includes('/mis-gestiones/formularios')) {
            const prestacionId = idprestacion?.split('_')[1] || idprestacion;
            const formId = idform;

            if (userId && prestacionId && formId) {
                getSolicitudPrestacionesEspecialesByID(userId, prestacionId, formId, (payload) => setData(dataUserWithExpedienteByOrigen(payload)));
            }
        }
    }, [expedienteIdByOrigen, idform, idprestacion, userId]);

    return (
        <div>
            <PageMenu title={'Solicitud de ayuda económico/social a través de la comisión de prestaciones especiales'}>

                <div className="btns-header-container">
                    <button aria-label="Volver atrás" onClick={() => navigate(-1)}>
                        <img src={IconArrowGray} alt="" />
                    </button>
                </div>
            </PageMenu>


            {
                loadingGetSolicitudPrestacionesEspecialesByID ?
                    <Loader activeLoader={true} label="Cargando Formulario"></Loader>
                    :
                    <SolicitudPrestacionesEspeciales
                        dataUser={data}
                        info={false}
                        origen={origenValue}
                        expedienteId={expedienteIdValue}
                    />
            }




        </div>
    )
}

export default HistorialSolicitudPrestacionesEspeciales